import { useMemo } from 'react'
import { format } from 'date-fns'
import { createTempOtpAsync, openResetOtpModal, resetTempOtpStatus } from '../../../../redux/flows/portal/lobby'
import { useAppDispatch, useAppSelector } from '../../../../redux/store'
import { APIStatus } from '../../../../redux/types'
import { notifyError, notifySuccess } from '../../../../utils/Notification'

export const usePatientProfile = () => {
  const dispatch = useAppDispatch()
  const { patientDetails, isResetOtpModalOpen, tempOtpStatus } = useAppSelector((state) => state.lobbyPortal)

  const currentPatient = patientDetails
  const currentVisit = patientDetails?.currentVisit
  const patientId = currentPatient?.patient?.id

  const formattedDate = useMemo(() => {
    const dob = currentPatient?.patient?.user?.dob
    if (!dob) return { dayName: '-', monthDay: '-' }

    const today = new Date()
    const birthDate = new Date(dob)
    const month = birthDate.getUTCMonth()
    const date = birthDate.getUTCDate()
    const dateToFormat = new Date(today.getUTCFullYear(), month, date)

    return {
      dayName: format(dateToFormat, 'EEEE'),
      monthDay: format(dateToFormat, 'MMM d'),
    }
  }, [currentPatient])

  const handleProfilePicClick = () => {
    dispatch(openResetOtpModal())
  }

  const handleResetOtpNo = () => {
    dispatch(resetTempOtpStatus())
  }

  const handleResetOtpYes = async () => {
    if (!patientId) {
      notifyError('Reset OTP', 'Patient not found')
      return
    }

    const result = await dispatch(createTempOtpAsync(patientId))

    if (createTempOtpAsync.fulfilled.match(result)) {
      const { message, created } = result.payload
      if (created) {
        notifySuccess('Reset OTP', 'OTP reset to 123456 for 10 minutes')
      } else {
        notifySuccess('Reset OTP', message || 'Phone already exists in test numbers')
      }
      dispatch(resetTempOtpStatus())
      return
    }

    notifyError('Reset OTP', result.payload || 'Failed to reset OTP')
  }

  return {
    currentPatient,
    currentVisit,
    formattedDate,
    isResetOtpModalOpen,
    isResetOtpLoading: tempOtpStatus === APIStatus.pending,
    handleProfilePicClick,
    handleResetOtpNo,
    handleResetOtpYes,
  }
}
